import useGetMenuLogo from '@/hooks/useGetMenuLogo'
import { generateImageSources } from '@/utils/uploadcare'
import Image from 'next/image'
import { cn } from 'oddle-shop-monorepo.design-system'
import React from 'react'
import { H2 } from '@/components/common/Typo'

interface HeaderLogoProps {
  isMobile?: boolean
  truncate?: boolean
  showStoreName?: boolean
  className?: string
  logoClassName?: string
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({
  isMobile,
  truncate = false,
  showStoreName: showStoreNameProps,
  className = '',
  logoClassName = '',
}) => {
  const { logoImage, font, showLogo, showStoreName, storeName } =
    useGetMenuLogo()
  const { src } = generateImageSources({ url: logoImage, baseW: 240 })
  const showStoreNamePropsFinal =
    showStoreNameProps === undefined ? showStoreName : showStoreNameProps

  return (
    <>
      {/* Desktop Version */}
      <div className={cn('hidden md:inline', className)}>
        <div className={cn('flex items-center', truncate ? '' : 'ml-3.5')}>
          {showLogo && src && (
            <Image
              alt={storeName}
              src={src}
              width={135}
              height={44}
              className={cn(
                'max-w-[135px] md:h-[60px] md:max-w-[180px]',
                truncate ? '' : 'mr-3 md:ml-3',
                logoClassName
              )}
              style={{ width: 'auto' }}
            />
          )}
          {showStoreNamePropsFinal && !isMobile && (
            <H2
              className="text-header-link-color mr-3 font-bold leading-tight"
              style={{
                fontFamily: font,
              }}
            >
              {storeName}
            </H2>
          )}
        </div>
      </div>

      {/* Mobile Version */}
      <div className={cn('md:hidden', className)}>
        {showLogo && src ? (
          <>
            <Image
              alt={storeName}
              src={src}
              width={135}
              height={44}
              className={cn('mr-3 max-h-[44px]', logoClassName)}
              style={{ width: 'auto', height: '44px' }}
            />
            {showStoreNameProps && (
              <H2
                className="text-header-link-color mb-7 mt-2.5 max-w-[161px] font-bold leading-8"
                style={{
                  fontFamily: font,
                }}
              >
                {storeName}
              </H2>
            )}
          </>
        ) : (
          showStoreNamePropsFinal && (
            <H2
              className="text-header-link-color max-w-[161px] font-bold leading-tight"
              style={{
                fontFamily: font,
              }}
            >
              {storeName}
            </H2>
          )
        )}
      </div>
    </>
  )
}

export default HeaderLogo
